import React from "react";

export default function Wordmark({ size = "md", className = "" }) {
  // size: sm | md | lg
  const sizes = {
    sm: { line1: "text-[13px]", line2: "text-[11.5px]" },
    md: { line1: "text-[15px]", line2: "text-[13px]" },
    lg: { line1: "text-[20px]", line2: "text-[17px]" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`wordmark-v2 leading-none select-none ${className}`}>
      <div
        className={`wm-denim font-display font-extrabold tracking-[-0.012em] uppercase whitespace-nowrap ${s.line1}`}
      >
        Brand New Money
      </div>
      <div className={`wm-films flex items-center gap-2 mt-1.5 ${s.line2}`}>
        <span className="font-serif-italic font-light text-ink/90">Films</span>
        <span className="wm-dot" aria-hidden />
      </div>
    </div>
  );
}
